import {
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  Timestamp,
} from "firebase/firestore";
import { db } from "./firebase";

export interface Guide {
  id: string;
  title: string;
  tag: string;
  price: string;
  videoUrl?: string;
  ebookUrl?: string;
  thumb?: string;
  previewUrl?: string; // amostra pública
  checkoutUrl?: string; // link de compra
  purchased?: boolean; // flag opcional para liberar PDF
  createdAt?: Timestamp;
}

const COLLECTION = "guides";

export async function getGuides(): Promise<Guide[]> {
  const snap = await getDocs(collection(db, COLLECTION));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Guide);
}

export async function saveGuide(guide: Guide): Promise<void> {
  const ref = doc(db, COLLECTION, guide.id || crypto.randomUUID());
  await setDoc(ref, {
    ...guide,
    createdAt: guide.createdAt || Timestamp.now(),
  });
}

export async function deleteGuide(id: string): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await deleteDoc(ref);
}
